<script>

export default {
  name: 'SearchOptions',

  props: {
    searchParams: Object
  },

  watch: {
    'searchParams.range'() {
      this.setRangeText()
    }
  },

  methods: {
    setRangeText() {
      this.$set(this.searchParams, 'rangeText', this.$refs['range'].selectedOptions[0].text)
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.setRangeText()
    })
  }

}


</script>

<template>

  <div class="grid-x grid-margin-x">
    <div class="cell medium-4">
      <label>Environment</label>
      <select ref="facility" v-model="searchParams.facility">
        <option value="ridesharing-dev">Ridesharing</option>
        <option value="production">Release</option>
        <option value="prerelease">Prerelease</option>
        <option value="development">Development</option>
      </select>
    </div>

    <div class="cell medium-4">
      <label>Range</label>
      <select ref="range" v-model="searchParams.range">
        <option :value="60*30">30 Minutes</option>
        <option :value="60*60">1 Hour</option>
        <option :value="60*60*3">3 Hours</option>
        <option :value="60*60*6">6 Hours</option>
        <option :value="60*60*12">12 Hours</option>
        <option :value="60*60*24*1">1 Day</option>
        <option :value="60*60*24*2">2 Days</option>
        <option :value="60*60*24*3">3 Days</option>
        <option :value="60*60*24*7">1 Week</option>
        <option :value="60*60*24*7*2">2 Weeks</option>
        <option :value="60*60*24*7*4">4 Weeks</option>
      </select>
    </div>

    <div class="cell medium-4">
      <label>Interval</label>
      <select ref="interval" v-model="searchParams.interval">
        <option value="minute">Minutely</option>
        <option value="hour">Hourly</option>
        <option value="day">Dayly</option>
        <option value="week">Weekly</option>
        <option value="month">Monthly</option>
      </select>
    </div>
  </div>

</template>

<style scoped>
</style>